<template>
    <div class="select">
        <div class="select-item" v-for="item in options" :key="item.id" @click="selectItem(item)">
            {{item.label ? item.label : item.title}}
        </div>
    </div>
</template>
<script>
export default {
    props:{
        options:Array,
        id:Number
    },
    data(){
        return {
            list:[],
        }
    },
    watch:{
        options:{
            handler(newVal){
                if(newVal.length > 0){
                    this.list = newVal
                }
            },
            deep:true,
            immediate:true
        }
    },
    methods:{
        selectItem(item){
            this.$emit('fatherSelectItem',item,this.id)
        }
    }
}
</script>
<style scoped lang="scss">
    @import '/style/phone/newProductDetils/fromComponent/selectComponent.scss';
    .select{
        border: 0.0625rem solid #E5E5E7;
        position: absolute;
        top: 3.5rem;
        width: 80%;
        background: #fff;
        left: 0;
        margin-top: 0.375rem;
        z-index: 99;
        .select-item{
            height: 3rem;
            display: flex;
            align-items: center;
            font-family: Inter;
            font-size: 0.875rem;
            padding:0 1rem;
        }
        .select-item:hover{
            background: #DCDFE6;
        }
    }
</style>
